import "./styles.scss";
import { getSvgComponent } from "../../utils/svgUtils";
import useApp from "../../hooks/useApp";

const PartnerListCard = ({ data, onClick }) => {
  const { selectedLanguage } = useApp();

  return (
    <div className="bank-list">
      {data.map((bank, idx) => (
        <div className="bank-card" key={idx} onClick={() => onClick(bank)}>
          <div className="bank-logo">
            <img
              src={getSvgComponent(bank.logo)}
              alt={bank.name[selectedLanguage?.value]}
            />
          </div>
          <div className="bank-apr">
            <span>{`APR ${bank.apr}`}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PartnerListCard;
